import { render } from "./questionDetail.vue?vue&type=template&id=61b8b77e&scoped=true"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"

import "./questionDetail.vue?vue&type=style&index=0&id=61b8b77e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b8b77e"]])

export default __exports__